module.exports = __webpack_public_path__ + "static/8-08ced6fef223f5fe8e9d9ac84c73ff63.jpg";